import React, { useRef } from 'react';

import Input from '../../../../components/Input';

import heart from '../../../../assets/home/heart.png';
import searchIcon from '../../../../assets/home/search.png';

import { Container } from './styles';

const Search = ({ setSearch }) => {
  const inputRef = useRef();

  const handleSearch = () => {
    const value = document.getElementById('search-favorite').value;
    setSearch(value);
  };

  return (
    <Container>
      <Input
        id="search-favorite"
        ref={inputRef}
        placeholder="Buscar"
        iconLeft={heart}
        iconRight={searchIcon}
        onClickIconRight={() => handleSearch()}
        onBlur={() => handleSearch()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch();
          }
        }}
      />
    </Container>
  );
};

export default Search;
